export function formatDate(iso, lang = "fr") {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(lang, { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function formatDateRange(start, end, lang = "fr") {
  const s = new Date(start), e = new Date(end);
  const sameDay = s.toDateString() === e.toDateString();
  const opts = { day: "2-digit", month: "short", year: "numeric" };
  if (sameDay) return s.toLocaleDateString(lang, opts);
  return `${s.toLocaleDateString(lang, { day: "2-digit", month: "short" })} – ${e.toLocaleDateString(lang, opts)}`;
}

export function formatTime(iso, lang = "fr") {
  try {
    return new Date(iso).toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });
  } catch { return ""; }
}

export function buildGoogleCalUrl(ev) {
  const fmt = (iso) => new Date(iso).toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.title,
    dates: `${fmt(ev.start_date)}/${fmt(ev.end_date)}`,
    details: ev.description?.slice(0, 500) || "",
    location: `${ev.venue}, ${ev.city}`,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
